module.exports = __webpack_public_path__ + "static/media/rocket.f61e84d0.svg";